import React, { Component } from "react";
import { connect } from "react-redux";
import { Base64func } from "../../../components/Base64Func/Base64func";
import TOOrderDetails from "../../../components/TOOrderDetails/TOOrderDetails";
import { AiOutlineScan } from "react-icons/ai";
import TMLoader from "../../../components/Loader/Loader";
import BarcodeScanner from "../../../components/BarcodeScanner/BarcodeScanner";
import { withRouter } from "react-router-dom";
import { message } from "antd";
import { getTOPickerOrderThunk } from "../../../redux/TOThunks/Action";
import { CURRENT_BOX } from "../../../constants";
export class TOPOProcess extends Component {
  state = {
    currentOrderId: null,
    showScannerScreen: false,
    serviceLoading: false,
    currTOData: null,
  };

  componentDidMount = () => {
    // ----------- Add condition to run picking logic on picker order flow
    localStorage.setItem("clearPickerCondition", 0);

    //------------ Getting order ID from url

    let toId = this.props.match?.params?.TOID;

    this.setState(
      {
        currentOrderId: Base64func(toId, "decode"),
        serviceLoading: true,
      },
      () => {
        let currentBox = localStorage.getItem(CURRENT_BOX)
          ? JSON.parse(localStorage.getItem(CURRENT_BOX))
          : "";

        // if (currentBox) {
        //   this.props.history.push(
        //     `/to-picker-order/TOID=${Base64func(currentBox, "encode")}`
        //   );
        // }
        //-------------- Service calls

        let data = {
          access_token: this.props.access_token,
          history: this.props.history,
          toNumber: this.state.currentOrderId,
        };

        this.props.getTOPickerOrderThunk(data).then(() => {
          this.setState({
            serviceLoading: false,
          });
          if (this.props.TOReducer?.TOOrderErr) {
            message.error(this.props.TOReducer?.TOOrderErr);
            this.props.history?.push("/to-picker");
          } else {
            if (!this.props.TOReducer?.TOOrderData) {
              message.error("No Data Found");
              this.props.history?.push("/to-picker");
            } else {
              this.setState({
                currTOData: this.props.TOReducer?.TOOrderData,
              });
            }
          }
        });
      }
    );
  };

  updateBoxId = () => {
    this.setState({ showScannerScreen: false });
  };

  render() {
    let {
      currTOData,
      serviceLoading,
      currentOrderId,
      showScannerScreen,
    } = this.state;

    let { warehouseList } = this.props;
    return (
      <div>
        {serviceLoading ? <TMLoader /> : null}

        <TOOrderDetails toData={currTOData} warehouseList={warehouseList} />

        <button
          className="bbtn"
          disabled={serviceLoading}
          onClick={() => this.setState({ showScannerScreen: true })}
        >
          <AiOutlineScan /> Scan the barcode
        </button>

        {showScannerScreen ? (
          <BarcodeScanner
            scan={showScannerScreen ? true : false}
            camera={showScannerScreen ? true : false}
            redirect={"to-picker"}
            orderId={currentOrderId}
            history={this.props.history}
            getBoxId={this.updateBoxId}
            boxUpdate={true}
            currTOData={this.state.currTOData}
            updateShowScannerScreen={(value) =>
              this.setState({
                showScannerScreen: value,
              })
            }
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  warehouseList: state.authReducer?.AuthData?.warehouseList,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
});

const mapDispatchToProps = {
  getTOPickerOrderThunk,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TOPOProcess)
);
